export type ArcData = {
  value: number;
  color: string;
};

const polarToCartesian = (cx: number, cy: number, r: number, angleInDegrees: number) => {
  const angleInRadians = (angleInDegrees * Math.PI) / 180.0;
  return {
    x: cx + r * Math.cos(angleInRadians),
    y: cy + r * Math.sin(angleInRadians),
  };
};

export const describeArc = (
  cx: number,
  cy: number,
  r: number,
  startAngle: number,
  endAngle: number,
  gap: number,
): string => {
  const adjustedEndAngle = endAngle - gap;
  const start = polarToCartesian(cx, cy, r, startAngle);
  const end = polarToCartesian(cx, cy, r, adjustedEndAngle);
  const largeArcFlag = adjustedEndAngle - startAngle <= 180 ? '0' : '1';

  return `M ${start.x} ${start.y} A ${r} ${r} 0 ${largeArcFlag} 1 ${end.x} ${end.y} L ${cx} ${cy} Z`;
};

export const describeInnerSemicircle = (center: number, innerRadius: number): string => {
  const radius = innerRadius - 8;
  const start = polarToCartesian(center, center, radius, 180);
  const end = polarToCartesian(center, center, radius, 0);
  return `M ${start.x} ${start.y} A ${radius} ${radius} 0 0 1 ${end.x} ${end.y} L ${center} ${center} Z`;
};

export const getOverlayCirclePosition = (center: number, radius: number, percentage: number, size: number) => {
  if (percentage <= 0 || percentage >= 100) return null;

  const circleRadius = size / 30; // e.g., 400px height -> ~13px radius
  const strokeWidth = size / 66; // e.g., 400px height -> ~6px stroke

  const adjustedPathRadius = radius - circleRadius;

  const angleDeg = 180 - (180 * percentage) / 100;
  const angleRad = (angleDeg * Math.PI) / 180;

  return {
    cx: center + adjustedPathRadius * Math.cos(angleRad),
    cy: center - adjustedPathRadius * Math.sin(angleRad),
    r: circleRadius,
    strokeWidth: strokeWidth, // Return the calculated stroke width
  };
};
